import React from 'react';
import { Dialog, VisuallyHidden } from 'tamagui';
import { LessonCompletionContent } from '../LessonCompletionContent';
import { Lesson } from '../../types';

interface LessonCompletionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  suggestions?: Lesson[];
  onSuggestionPress?: (lesson: Lesson) => void;
  onBack?: () => void;
  courseName?: string;
}

// Modal Component (Desktop/Tablet)
export const LessonCompletionModal = ({
  open,
  onOpenChange,
  suggestions = [],
  onSuggestionPress,
  onBack,
  courseName
}: LessonCompletionModalProps) => {

  if (!open) return null;

  return (
    <Dialog modal open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay 
          key="overlay"
          animation="quick"
          opacity={0.6}
          backgroundColor="rgba(0, 0, 0, 0.6)"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
          onPress={() => onOpenChange(false)}
        />
        <Dialog.Content
          elevate
          animation="quick"
          alignItems="center"
          justifyContent="center"
          backgroundColor="transparent"
          padding="$0"
          width={450}
          height={450}
        >
          <VisuallyHidden>
            <Dialog.Title>Lesson Completed</Dialog.Title>
          </VisuallyHidden>
          <LessonCompletionContent 
            suggestions={suggestions} 
            onClose={() => onOpenChange(false)}
            onBack={onBack}
            courseName={courseName}
            onSuggestionPress={onSuggestionPress}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};